
import { useSelectPersonsInIncidentFieldQuery } from 'generated/graphql';

import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery(projectId: string) {
  const tuple = useSelectPersonsInIncidentFieldQuery({
    variables: {
      options: {
        // filter: {
        // }
        filter: {
          projectId
        }
      }
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {


      const data: IData[] = tuple.data?.persons.map((node) => ({
        id: node.id,
        name: node.id,
        displayName: node.fullName
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
